import DealerStatusList from './DealerStatusList';

export default DealerStatusList;
